import Cookies from 'js-cookie'

import type { SessionTokens, StoredAuthData } from '@/types/session'

const TokenKey = 'Admin-Token'
const ExpiresKey = 'Token-Expires-In'
const ExpiresDateKey = 'Date-Expires-In'
const RefreshTokenKey = 'Refresh-Token'
const RefreshTokenExpires = 'Refresh-Token-Expires-In'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token: string) {
  return Cookies.set(TokenKey, `Bearer ${token}`)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setAuthData({ accessToken, refreshToken, expiresIn, refreshExpiresIn }: SessionTokens) {
  Cookies.set(TokenKey, `Bearer ${accessToken}`)
  Cookies.set(ExpiresKey, String(expiresIn))
  Cookies.set(ExpiresDateKey, String(getExpiresInDate(expiresIn)))
  Cookies.set(RefreshTokenKey, refreshToken)
  Cookies.set(RefreshTokenExpires, String(refreshExpiresIn))
}

export function getAuthData(): StoredAuthData {
  return {
    accessToken: Cookies.get(TokenKey),
    refreshToken: Cookies.get(RefreshTokenKey),
    expiresIn: Cookies.get(ExpiresKey),
    expiresInDate: Cookies.get(ExpiresDateKey),
    refreshExpiresIn: Cookies.get(RefreshTokenExpires)
  }
}

export function removeAuthData() {
  Cookies.remove(TokenKey)
  Cookies.remove(ExpiresKey)
  Cookies.remove(ExpiresDateKey)
  Cookies.remove(RefreshTokenKey)
  Cookies.remove(RefreshTokenExpires)
}

function getExpiresInDate(expiresIn: number): number {
  const nowMs = +new Date()
  const expiresMs = nowMs + expiresIn * 1000
  return +new Date(expiresMs)
}
